import { queryKeys as contractQueryKeys } from '../useQueryContract'
import { useFetchDocumentSignature } from './useFetchContractSignature'

const getContractByIdQueryKey = (contractId: string) => contractQueryKeys.byId({ id: contractId })

const useDefaultCallbacks = () => {
  const queryClient = useQueryClient()

  const onMutate = ({ contractId }: { contractId: string }) =>
    queryClient.cancelQueries(getContractByIdQueryKey(contractId))

  const onSettled = (_: any, _1: any, { contractId }: { contractId: string }) =>
    queryClient.invalidateQueries(getContractByIdQueryKey(contractId))

  return {
    onMutate,
    onSettled,
  }
}

const update = () => {
  const { update } = useFetchDocumentSignature()
  const defaultCallbacks = useDefaultCallbacks()

  return useMutation({
    mutationFn: update,
    ...defaultCallbacks,
  })
}

const invite = () => {
  const { invite } = useFetchDocumentSignature()
  const defaultCallbacks = useDefaultCallbacks()

  return useMutation({
    mutationFn: invite,
    ...defaultCallbacks,
  })
}

const cancel = () => {
  const { cancel } = useFetchDocumentSignature()
  const defaultCallbacks = useDefaultCallbacks()

  return useMutation({
    mutationFn: cancel,
    ...defaultCallbacks,
  })
}

const inviteAllSignees = () => {
  const { inviteAllSignees } = useFetchDocumentSignature()
  const defaultCallbacks = useDefaultCallbacks()

  return useMutation({
    mutationFn: inviteAllSignees,
    ...defaultCallbacks,
  })
}

const reopen = () => {
  const { reopen } = useFetchDocumentSignature()
  const defaultCallbacks = useDefaultCallbacks()

  return useMutation({
    mutationFn: reopen,
    ...defaultCallbacks,
  })
}

const sign = () => {
  const { sign } = useFetchDocumentSignature()
  const { onMutate, onSettled } = useDefaultCallbacks()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: sign,
    onMutate: (variables) => {
      onMutate(variables)
    },
    onSuccess: (responseData, { contractId }) => {
      queryClient.setQueryData(
        getContractByIdQueryKey(contractId).queryKey,
        responseData,
      )
    },
    onError: (_, { contractId }) => onSettled(undefined, undefined, { contractId }),
  })
}

export const useMutationContractSignature = {
  sign,
  cancel,
  update,
  invite,
  inviteAllSignees,
  reopen,
}
